import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'
import * as ds from '@attain-apps/fe/web/main/lib/design'
import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import * as router from '@attain-apps/fe/web/main/lib/router'

import * as me from '../../../me'
import * as routeBound from '../../../route-bound'

import { Api } from './api.service'
import * as effects from './effects'
import * as plugins from './plugins'
import type { TypeParams } from './types'
// TODO: Centralize the default quantity so it can be used across the other
// collections
const DEFAULT_QUANTITY = 20

/** Space clusters collection. */
@ngCore.Injectable()
export class Collection extends ec.Collection<TypeParams> {
  /** @see {@link router.Router} */
  private readonly _router = ngCore.inject(router.Router)
  /** @see {@link me.Feature} */
  private readonly _meFeature = ngCore.inject(me.Feature)

  constructor() {
    super({
      api: ngCore.inject(Api),
      context$: ngCore.inject(routeBound.scenario.Context.TOKEN),
      identify: cluster => cluster.id,
      name: ec.Name.Predefined.SpaceCluster,
      plugins: {
        additionalFactories: [
          new ds.input.select.singleEc.ec.Factory<TypeParams>({
            getItem: ({ id, name }) => ({
              label: name,
              value: id,
            }),
          }),
          new plugins.functionalUsage.Factory(),
          new plugins.warnings.Factory(),
          new ds.table.ec.Factory<TypeParams>(collection => ({
            rowConfig: ({ entity, rowIdx }) => ({
              iconsConfigs: [
                {
                  class: 'atn-icon atn-trash atn-red',
                  onClick: () => {
                    collection.plugins.editingPlugin.feature.actions.markForDeletion
                      .from(
                        `Clusters.Table.Row-${entity.id}.Icons.Trash.Clicked`,
                      )
                      .dispatch({ id: entity.id })
                  },
                },
              ],
              onClick: () => {
                const source = `Clusters.Table.Row-${rowIdx}.Clicked`

                this.plugins.currentEntityPlugin.storage.actions.putInIdLookup
                  .from(source)
                  .dispatch({
                    value: entity.id,
                  })

                const url = this._meFeature.contexts.selectors
                  .getUrlForLink({
                    goto: {
                      navigationId: ents.extra.prebuilt.Page.Id.SpaceCluster,
                    },
                  })
                  .asSignal()

                if (url) {
                  this._router.actions.navigate.from(source).dispatch({ url })
                }
              },
            }),
          })),
        ],
        currentList: {
          quantity: {
            get: quantity => quantity ?? DEFAULT_QUANTITY,
          },
        },
      },
    })

    this.feature.registerEffects(effects.reloadOnClusterAssignmentChange(this))
  }
}
